import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SabreTextDialogComponent } from '@shared/components/sabre-text-dialog/sabre-text-dialog.component';
import { DecsStore } from '@shared/services/decs/decs.store';

interface ActivityData {
  code: string;
  description: string;
  date?: string;
  position?: string;
  sequenceNumber?: string;
}

@Component({
  selector: 'app-activity-description-dialog',
  templateUrl: './activity-description-dialog.component.html',
  styleUrls: ['./activity-description-dialog.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityDescriptionDialogComponent {
  isDFP = false;
  isSeqError = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ActivityData,
    private router: Router,
    private dialog: MatDialog,
    private decsStore: DecsStore,
  ) {
    if (data.code === '24' || data.code === 'G2' || data.code === 'M2') {
      this.isDFP = true;
    } else if (data.description.startsWith('Error')) {
      this.isSeqError = true;
    }
  }

  onViewSeqClick(): void {
    if (this.data.date && this.data.position && this.data.sequenceNumber) {
      this.router.navigate([
        'sequence',
        this.data.sequenceNumber,
        this.data.position,
        this.data.date,
      ]);

      this.dialog.closeAll();
    }
  }

  onViewHssClick(): void {
    const sabreCmd = `hss/${this.data.position}/${this.data.sequenceNumber}/${this.data.date}`;

    this.dialog.open(SabreTextDialogComponent, {
      data: {
        sabreText$: this.decsStore.submitDecsRequest(sabreCmd, false),
        refreshFn: this.decsStore.refreshFn,
        request: sabreCmd,
      },
      panelClass: 'sabre-text',
      maxHeight: '95vh',
      maxWidth: '100vw',
    });
  }
}
